import { useRef } from 'react';

import type { PlanningEntity } from './PlanningContainer';
import type { FC, SyntheticEvent } from 'react';

import { Typography } from '@mui/material';
import { StyledAccordion, StyledAccordionSummary, StyledAccordionDetails } from '../boxes/accordion/accordion';
import { EntityBox } from './EntityBox';

export const GroupLayout: FC<{
  title: string;
  entities: Array<PlanningEntity>;
  isExpanded: boolean | undefined;
}> = ({ title, entities, isExpanded = false }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <StyledAccordion
      defaultExpanded={isExpanded}
      onChange={(_: SyntheticEvent, expanded: boolean): void => {
        if (!expanded) return;

        setTimeout(() => {
          if (!contentRef.current) return;
          contentRef.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }, 200);
      }}
    >
      <StyledAccordionSummary aria-controls="panel1-content" id="panel1-header">
        <Typography>{title}</Typography>
      </StyledAccordionSummary>
      <StyledAccordionDetails ref={contentRef}>
        {entities.map((entity: PlanningEntity, index: number) => (
          <EntityBox key={index} entity={entity} />
        ))}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
